/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IAuthorizer, IAuthorizerInterface } from "../IAuthorizer";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "actionId",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "where",
        type: "address",
      },
    ],
    name: "canPerform",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IAuthorizer__factory {
  static readonly abi = _abi;
  static createInterface(): IAuthorizerInterface {
    return new utils.Interface(_abi) as IAuthorizerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IAuthorizer {
    return new Contract(address, _abi, signerOrProvider) as IAuthorizer;
  }
}
